import { Mail, MailX, Send } from 'lucide-react';
import { ActionRowView } from '../../widget-native/viewir/components/actionrow';
import { ROW_BOX } from './mailStyles';
import { mailLinkTarget } from './mailUtils';

const ORANGE = '#FF9F0A';
const PAGE_ICONS = { 'review.html': Send, 'unsubscribe.html': MailX };

export default function MailLinkCard({ data, onOpenTarget }) {
  const target = mailLinkTarget(data);
  const attention = data?.tone === 'attention';
  const title = typeof data?.title === 'string' && data.title.trim() ? data.title : 'Inbox report';
  const subtitle = typeof data?.subtitle === 'string' ? data.subtitle : '';
  const Icon = PAGE_ICONS[target?.pageFile] || Mail;
  const clickable = Boolean(target && onOpenTarget);

  const row = (
    <ActionRowView
      variant="card"
      glyph={<Icon size={16} color={attention ? ORANGE : '#111111'} aria-hidden="true" />}
      tone={attention ? ORANGE : undefined}
      title={title}
      subtitle={subtitle}
      subtitleTone={attention ? ORANGE : undefined}
      trailing="chevron"
    />
  );
  if (!clickable) {
    return <div style={ROW_BOX} data-testid="mail-link">{row}</div>;
  }
  return (
    <button
      type="button"
      style={{ ...ROW_BOX, padding: 0, border: 'none', background: 'transparent', textAlign: 'left', cursor: 'pointer' }}
      data-testid="mail-link"
      onClick={() => onOpenTarget(target)}
    >
      {row}
    </button>
  );
}
